import { RenalDetectRecommendation } from '@app/core/models';
import { createAction, props } from '@ngrx/store';
import { RenalDetectChoiceValues } from '../../components/renal-detect-choice-form/renal-detect-choice-form';
import { RenalDetectDetectionValues } from '../../components/renal-detect-detection-form/renal-detect-detection-form';

/**
 * Actions to set forms
 */
export const setRenalDetectDetection = createAction('[Renal Detect] Set Detection Values', props<{ value: RenalDetectDetectionValues }>());
export const setRenalDetectNutritionRecommendationChoice = createAction(
  '[Renal Detect] Set Recommendation Values',
  props<{ value: RenalDetectChoiceValues }>(),
);

/**
 * Actions dispatched to retrieve renal recommendation
 */
export const getRenalDetectRecommendation = createAction('[Renal Detect] Get Recommendation');
export const getRenalDetectRecommendationSuccess = createAction(
  '[Renal Detect] Get Recommendation Success',
  props<{ recommendation: RenalDetectRecommendation }>(),
);
